module.exports = __webpack_public_path__ + "resource/img/minus_form.d532c850.svg";